import guid from '../services/mini/guid';
import _ from 'lodash';
import convertNodeToPhrase from '../services/mini/convertNodeToPhrase';
import { alanMarkdown } from '../../../alan_btn/src/textChat/alanMarkdown';
import * as PegParser from '../services/ExpectedResponsePegParser';
const { convert } = require('html-to-text');

function isVisualStateNode(node) {
    return node.request && node.request.visualState;
}

class Node {
    constructor(id, request) {
        this.id = id || guid();
        this.request = request;
        this.children = [];
        this.parentId = null;
        this.testCaseId = null;
        this.meta = {};
        this.visualProperties = {};
        this.response = [];
        this.responseForUi = [];
        this.childIndex = null;
    }

    markAsStartConversationNode(conversationId) {
        this.conversationId = conversationId;
        this.parentId = '';
    }

    isEmpty() {
        return this.request === null;
    }

    hasFilledResuest() {
        return !!this.request;
    }

    hasEmptyChildren() {
        let hasEmptyChildren = false;

        for (let i = 0; i < this.children.length; i++) {
            if (!this.children[i].hasFilledResuest()) {
                hasEmptyChildren = true;
                break;
            }
        }

        return hasEmptyChildren;
    }

    addChild(node, position) {
        node.root = this.root || this;
        if (this.testCaseId && !node.testCaseId) {
            node.testCaseId = this.testCaseId;
        }
        if (!node.conversationId) {
            node.parentId = this.id;
            node.conversationId = this.conversationId;
        }

        if (_.isString(node.visualProperties)) {
            try {
                node.visualProperties = JSON.parse(node.visualProperties);
            } catch (e) {
                node.visualProperties = {};
            }
        }

        if (node.visualProperties && !_.isUndefined(node.visualProperties.childIndex)) {
            node.childIndex = node.visualProperties.childIndex;
        }

        if (_.isUndefined(node.childIndex) || node.childIndex === null) {
            node.childIndex = this.children.length;
            node.visualProperties.childIndex = node.childIndex;
        }

        if (!_.isUndefined(position)) {
            this.children.splice(position, 0, node);
            this.children.forEach((el, index) => {
                el.childIndex = index;
                el.visualProperties.childIndex = index;
            });
        }
        else {
            this.children.push(node);
            this.children = _.sortBy(this.children, 'childIndex');
        }
    }

    hasChildren() {
        return this.children.length > 0;
    }

    clearChildren() {
        this.children = [];
    }

    findNode(id) {
        let neededNode = null;

        if (this.id === id) {
            return this;
        }

        if (this.hasChildren()) {
            for (var i = 0; i < this.children.length; i++) {
                neededNode = this.children[i].findNode(id);
                if (neededNode) {
                    return neededNode;
                }
            }
        }

        return null;
    }

    removeChildrenById(id, keepChildren) {
        let deletedNodeInd = 0;
        let deletedNode = null;
        for (let i = 0; i < this.children.length; i++) {
            if (this.children[i].id === id) {
                deletedNode = this.children[i];
                break;
            } else {
                deletedNodeInd++;
            }
        }

        if (keepChildren && deletedNode.children.length > 0) {
            deletedNode.children[0].parentId = deletedNode.parentId;
            this.children = [
                ...this.children.slice(0, deletedNodeInd),
                deletedNode.children[0],
                ...this.children.slice(deletedNodeInd + 1, this.children.length)
            ];
        } else {
            this.children.splice(deletedNodeInd, 1);
        }
        this.children.forEach((el, index) => {
            el.childIndex = index;
            el.visualProperties.childIndex = index;
        });
    }

    findParentNodeByConversationId(conversationId) {
        let neededNode = null;

        if (this.conversationId === conversationId) {
            return this;
        }

        if (this.hasChildren()) {
            for (var i = 0; i < this.children.length; i++) {
                neededNode = this.children[i].findParentNodeByConversationId(conversationId);
                if (neededNode) {
                    return neededNode;
                }
            }
        }

        return null;
    }

    getEmptyChild() {
        for (var i = 0; i < this.children.length; i++) {
            if (!this.children[i].request) {
                return this.children[i];
            }
        }
        return null;
    }

    getAllParentNodes() {
        let parentNode;
        let parentNodes = [];

        if (this.parentId) {
            parentNode = this.root.findNode(this.parentId);
            if (parentNode) {
                parentNodes.unshift(parentNode);
                if (parentNode.parentId) {
                    parentNodes = [...parentNode.getAllParentNodes(), ...parentNodes];
                } else {
                    return parentNodes;
                }
            }
        }

        return parentNodes;
    }

    getAllChildren() {
        let nodes = [];
        if (this.children.length > 0) {
            for (var i = 0; i < this.children.length; i++) {
                nodes.push(this.children[i]);
                if (this.children[i].hasChildren()) {
                    nodes = [...nodes, ...this.children[i].getAllChildren()];
                }
            }
        }
        return nodes;
    }

    setExpectedResponse(response) {
        this.visualProperties = {
            ...this.visualProperties,
            expectedResponses: response
        };
    }

    deleteAllExpectedResponses() {
        delete this.visualProperties.expectedResponses;
    }

    reFillNode(node, saveNodeOrder) {
        this.conversationId = node.conversationId;
        this.id = node.id;
        this.parentId = node.parentId;
        this.response = node.response;
        this.request = node.request;
        this.testCaseId = node.testCaseId;

        if (!saveNodeOrder) {
            this.visualProperties = node.visualProperties;
        }

        let nodeMeta;

        if (_.isString(node.meta)) {
            try {
                nodeMeta = JSON.parse(node.meta);
            } catch (e) {
                nodeMeta = {};
            }
        } else {
            nodeMeta = node.meta;
        }

        this.meta = { ...this.meta, ...nodeMeta };

        if (_.isString(this.visualProperties)) {
            try {
                this.visualProperties = JSON.parse(this.visualProperties);
            } catch (e) {
                this.visualProperties = {};
            }
        }

        if (this.visualProperties) {
            if (!_.isUndefined(this.visualProperties.childIndex)) {
                this.childIndex = this.visualProperties.childIndex;
            }
            // convert old expected responses to new ones
            if (_.isArray(this.visualProperties?.expectedResponses) &&
                this.visualProperties?.condition) {
                this.visualProperties.expectedResponses = this.visualProperties.expectedResponses.map(el => `"${el.replace(/"/g, '\\"')}"`).join(` ${this.visualProperties.condition} `);
                delete this.visualProperties.condition;
            }
        }

        if (_.isString(this.response)) {
            try {
                this.response = JSON.parse(this.response);
            } catch (e) {
                this.response = [];
            }
        }

        this.responseForUi = [];
        for (let i = 0; i < this.response.length; i++) {
            if (!this.responseForUi) {
                this.responseForUi = [];
            }
            if (this.response[i].data) {
                let lastResponseForUiItem = this.responseForUi[this.responseForUi.length - 1];

                if (!lastResponseForUiItem?.commands) {
                    this.responseForUi.push({ commands: [] });
                }

                this.responseForUi[this.responseForUi.length - 1].commands.push({
                    id: guid(),
                    data: this.response[i].data
                });
            } else {
                this.responseForUi.push(this.response[i]);
            }
        }
    }

    setChildIndex(index) {
        this.childIndex = index;
        this.visualProperties.childIndex = index;
    }

    changeNodeStructure(node, innerNodes) {
        let childNodes = [];
        this.reFillNode({ ...node, testCaseId: this.testCaseId });

        childNodes = innerNodes.filter((node) => {
            return node.parentId === this.id;
        });

        for (let i = 0; i < childNodes.length; i++) {
            let newNode = new Node();
            newNode.reFillNode(childNodes[i]);
            this.addChild(newNode);
        }

        if (this.children.length > 0) {
            for (let i = 0; i < this.children.length; i++) {
                this.children[i].changeNodeStructure(this.children[i], innerNodes);
            }
        } else {
            return null;
        }
    }

    isNodeOrParent(nodeId) {
        if (this.id === nodeId) {
            return true;
        } else {
            return this.getAllChildren()
                .map(node => node.id)
                .indexOf(nodeId) >= 0;
        }
    }

    cleanUiProps() {
        this.ui = null;
        if (this.hasChildren()) {
            for (var i = 0; i < this.children.length; i++) {
                this.children[i].ui = null;
                this.children[i].cleanUiProps();
            }
        }
    }

    setUiPropsForAllChildren(ui) {
        if (this.hasChildren()) {
            for (var i = 0; i < this.children.length; i++) {
                this.children[i].ui = { ...ui };
                this.children[i].setUiPropsForAllChildren(ui);
            }
        }
    }

    getVsInfo(node, counter) {
        let res = { number: 0, visualStateNodeId: null };
        if (isVisualStateNode(this)) {
            if (!this.ui) {
                this.ui = {
                    number: counter.num + 1,
                    visualStateNodeId: this.id,
                };
                counter.num = this.ui.number;
            } else {
                this.ui.number = counter.num + 1;
                this.ui.visualStateNodeId = this.id;
                counter.num = this.ui.number;
            }

            this.setUiPropsForAllChildren(this.ui);
        }

        if (this.id === node.id) {
            return {
                number: this.ui ? this.ui.number : 0,
                visualStateNodeId: this.ui ? this.ui.visualStateNodeId : null,
                final: true
            };
        }

        if (this.hasChildren()) {
            for (var i = 0; i < this.children.length; i++) {
                res = this.children[i].getVsInfo(node, counter);
                if (this.children[i].id === node.id || res.final) {
                    break;
                }
            }
        }

        return res;
    }

    hasUnrecognisedRequest() {
        if (this.meta?.pLoc?.file !== undefined && this.meta?.pLoc?.line !== undefined) {
            return false;
        }
        return true;
    }

    hasUnrecognisedResponse() {
        for (let i = 0; i < this.response.length; i++) {
            if (this.response[i].text) {
                if (!this.response[i].rLoc?.file) {
                    return true;
                }
            }
        }
        return false;
    }

    isPassed() {
        let isValid = null;
        if (this.visualProperties?.expectedResponses?.length > 0) {
            const expectedResponses = this.visualProperties.expectedResponses
                .replace(/\s\s+/g, ' ');

            let textResponses = [];
            let allResponses = '';
            for (let i = 0; i < this.response.length; i++) {
                if (this.response[i].text) {
                    textResponses.push(this.response[i].text);
                }
                if (this.response[i].links) {
                    for (let j = 0; j < this.response[i].links.length; j++) {
                        textResponses.push(this.response[i].links[j].title);
                        textResponses.push(this.response[i].links[j].href);
                    }
                }
            }

            allResponses = convert(alanMarkdown(textResponses.join(' ')), {}).toLowerCase().replace(/\s\s+/g, ' ').replace(/\n/g, " ");

            try {
                const parsedTreeCondition = PegParser.parse(expectedResponses);
                isValid = this.testConditionTree(parsedTreeCondition, allResponses);
            } catch (e) {
                isValid = false;
            }
        }
        return isValid;
    }

    testConditionTree(parsedTree, responses) {
        if (_.isString(parsedTree)) {
            return this.testOperation(responses, parsedTree);
        } else {
            if (_.isObject(parsedTree)) {
                if (parsedTree.operation === 'or') {
                    if (parsedTree.left === '' || parsedTree.right === '') {
                        return true;
                    }
                    return this.testConditionTree(parsedTree.left, responses) ||
                        this.testConditionTree(parsedTree.right, responses);
                }
                if (parsedTree.operation === 'and') {
                    return this.testConditionTree(parsedTree.left, responses) &&
                        this.testConditionTree(parsedTree.right, responses);
                }

                if (parsedTree.operation === 'not') {
                    return !this.testConditionTree(parsedTree.operand, responses);
                }
            }
        }
    }

    testOperation(responses, expectedResponse) {
        const expectedResponseRegexp = new RegExp(`(\\b|\\s)(${expectedResponse.toLowerCase().replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&')})`);
        return !!responses.match(expectedResponseRegexp);
    }

    isPassedRecursively() {
        const passedResults = [this, ...this.getAllChildren()].map(node => node.isPassed());
        const failedNodes = passedResults.filter(passed => passed === false);
        const passedNodes = passedResults.filter(passed => passed === true);

        if (failedNodes.length > 0) return false;
        if (passedNodes.length > 0 && failedNodes.length === 0) return true;
        return null;
    }

    hasUnrecognisedResponsesRecursively() {
        const unrecognisedResults = [this, ...this.getAllChildren()]
            .map(node => node.hasUnrecognisedResponse())
            .filter(unrecognised => unrecognised === true);
        return unrecognisedResults.length > 0;
    }

    fillTestCaseId() {
        this.testCaseId = 'ts-' + guid();
    }

    getTree(phrases) {
        let newNode;
        if (phrases.length > 0) {
            for (let i = 0; i < phrases.length; i++) {
                phrases[i].conversationId = this.id;
                if (phrases[i].parentId === '') {
                    newNode = new Node();
                    newNode.markAsStartConversationNode(this.id);
                    newNode.fillTestCaseId();
                    newNode.reFillNode({ ...newNode, ...phrases[i] });
                    this.addChild(newNode);
                    newNode.changeNodeStructure(phrases[i], phrases);
                }
            }
        } else {
            let newNode = new Node();
            newNode.markAsStartConversationNode(this.id);
            newNode.fillTestCaseId();
            this.addChild(newNode);
        }

        return this;
    }

    isValuesEqual(node) {
        const currentNodes = [this, ...this.getAllChildren()].map(n => {
            return { ...n.toPhrase(), id: '', parentId: '' };
        });
        const externalNodes = [node, ...node.getAllChildren()].map(n => {
            return { ...n.toPhrase(), id: '', parentId: '' };
        });
        return JSON.stringify(currentNodes) === JSON.stringify(externalNodes);
    }

    toDialogs(dialogs, childInd) {
        let keys = Object.keys(dialogs);
        let dialogKey;
        if (keys.length === 0) {
            dialogKey = `branch-${keys.length + 1}`;
            dialogs[dialogKey] = [];
        }

        keys = Object.keys(dialogs);

        if (this.parentId !== null) {
            if (childInd === 0) {
                dialogKey = keys[keys.length - 1];
                dialogs[dialogKey].push(this);
            } else {
                dialogKey = `branch-${keys.length + 1}`;
                const copiedNodes = [];
                if (this.parentId !== '') {
                    const parentNodes = this.getAllParentNodes();
                    for (let i = 0; i < parentNodes.length; i++) {
                        const tempNode = new Node();
                        tempNode.reFillNode(parentNodes[i]);
                        tempNode.id = guid();
                        copiedNodes.push(tempNode);
                    }

                    for (let i = 0; i < copiedNodes.length - 1; i++) {
                        if (i === 0) {
                            copiedNodes[i].markAsStartConversationNode();
                            copiedNodes[i].setChildIndex(keys.length + 1);
                        } else {
                            copiedNodes[i].setChildIndex(0);
                        }
                        copiedNodes[i].addChild(copiedNodes[i + 1]);
                        copiedNodes[i + 1].parentId = copiedNodes[i].id;
                    }
                    if (copiedNodes.length > 0) {
                        this.parentId = copiedNodes[copiedNodes.length - 1].id;
                        this.setChildIndex(0);
                    }
                }

                dialogs[dialogKey] = [...copiedNodes, this];
            }
        }

        for (let i = 0; i < this.children.length; i++) {
            this.children[i].toDialogs(dialogs, i);
        }

        return dialogs;
    }

    toPhrase() {
        return convertNodeToPhrase(this);
    }

}

export default Node;